var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.classNameBase.rootElement,
    ("" + (_vm.classNameBase.rootElement) + (_vm.classNameDirection[_vm.isYouSent]))
  ]},[(_vm.message)?_c('p',{attrs:{"wovn-ignore":""}},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('DecorationSpeechBubble',{class:[
      _vm.classNameBase.triangle,
      ("" + (_vm.classNameBase.triangle) + (_vm.classNameDirection[_vm.isYouSent]))
    ],attrs:{"direction":_vm.triangleDirection[_vm.isYouSent],"terminal":_vm.isSp ? 'sp' : 'pc'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }